<template>
  <portlet
      :icon="'fad fa-exclamation-triangle'"
      :title="$t('deviations.title')"
      :footer="true"
  >
    <template slot="portletBody">
      <form>
        <div class="form-group form-row ">

          <div :class=" type == 'excess' ? 'col-10' : 'col-12'">
            <label for="chooseDeviation"> {{ $t('deviations.chooseDeviation') }}</label>
            <select class="form-control" id="chooseDeviation" v-model="type">
              <option value="shortage" v-if="$route.query.blockShortage !== 'true'">{{ $t('deviations.deviations.shortage') }}</option>
              <option value="unit">{{ $t('deviations.deviations.unit') }}</option>
              <option value="excess">{{ $t('deviations.deviations.excess') }}</option>
              <option value="damaged">{{ $t('deviations.deviations.damaged') }}</option>

              <option v-show="$route.query.location == 'loading'" value="exceeds_cargo_limits">
                {{ $t('deviations.deviations.exceedsCargoLimits') }}
              </option>
            </select>
          </div>
          <div v-if="type == 'excess' " class="col-2">
            <label for="amount">{{ $t('deviations.amount') }}</label>
            <input id="amount" type="number" class=form-control min="1" v-model.number="amount">
          </div>
        </div>
        <div class="form-group form-row ">

          <div class="col">
            <label for="remark">{{ $t('form.remark') }}</label>
            <textarea id="remark" class="form-control" rows="5" v-model="remark">

            </textarea>
          </div>
        </div>

        <div class="form-group">
          <div v-if="!temporaryImage" @click="handleCamera" class="image-wrapper">
            <i v-if="loadingImage " class="far fa-spinner fa-spin loading-image"></i>
            <i v-if="!loadingImage" class="far fa-camera camera-icon"></i>
          </div>
          <v-touch
              v-if="temporaryImage"
              class="image-wrapper"
              @press="deleteImage">
            <img :src="temporaryImage">
          </v-touch>
        </div>
      </form>
    </template>

    <div slot="portletFooter" class="col text-right">

      <button type="submit" class="btn btn-primary ml-4" @click="saveDeviation">{{ $t('button.save') }}</button>
    </div>

  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';


export default {
  data() {
    return {
      temporaryImage: null,
      type: 'shortage',
      resizedImage: null,
      amount: 1,
      remark: '',
      loadingImage: false
    };
  },
  computed: {
    ...mapGetters('users', [
      'getMeBasic'
    ])
  },
  methods: {
    handleCamera() {

      navigator.camera.getPicture(this.cameraSuccess, (err) => {
        console.error(err);
        this.loadingImage = false;
      }, {
        destinationType: 1, // FILE_URI
        quality: 100,
        allowEdit: false
      });
    },
    cameraSuccess(e) {
      var self = this;
      this.loadingImage = true;
      window.resolveLocalFileSystemURL(e, function (fileEntry) {
        fileEntry.file(function (fileObj) {
          self.createImage(fileObj);
        });
      });
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      let self = this;

      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let image = new Image();
        image.onload = function (imageEvent) {
          let canvas = document.createElement('canvas'),
              max_size = 1024,
              width = image.width,
              height = image.height;
          if (width > height) {
            if (width > max_size) {
              height *= max_size / width;
              width = max_size;
            }
          } else {
            if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
          }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(image, 0, 0, width, height);
          let dataUrl = canvas.toDataURL('image/jpeg');
          self.temporaryImage = dataUrl;
          self.resizedImage = self.dataURItoBlob(dataUrl);
          self.tempImage = dataUrl;
          self.loadingImage = false;

          self.$emit('image', dataUrl);
        };
        image.src = e.target.result;
      };
    },
    dataURItoBlob(dataURI) {
      let byteString = atob(dataURI.split(',')[1]);
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      let ab = new ArrayBuffer(byteString.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {type: mimeString});
    },
    deleteImage() {
      navigator.vibrate(50);
      this.$swal({
        position: 'top-end',
        text: this.$root.$t('deviations.removeImage'),
        showConfirmButton: true,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.temporaryImage = null;
          this.resizedImage = null;
        }
      });
    },
    async saveDeviation() {
      let self = this;
      if (self.resizedImage) {
        let imageObj = {
          file: self.resizedImage,
          path: 'deviations/',
          name: Math.floor(Date.now() / 1000)
        };
        let uploadedFile = await this.$FB_UPLOADER.upload(imageObj)
        let url = await uploadedFile.ref.getDownloadURL()
        let user = this.getMeBasic;
        let deviationData = {
          type: self.type,
          imageId: imageObj.name,
          userId: user.userId,
          userName: user.userName,
          companyId: user.companyId,
          location: self.$route.query.location,
          pickLocationAtMomentOfRegistering: self.$route.query.picklocation === 'undefined' ? null : self.$route.query.picklocation,
          locationAdditional: self.$route.query.locationAdditional, // barcode of de trailer
          remark: self.remark,
          amount: self.amount,
          image: url,
          orderId: this.$route.query.location === 'loading' ? parseInt(this.$route.query.orderId) : this.$route.query.orderId,
          recordId: this.$route.query.recordId ? this.$route.query.recordId : null
        };
        return self.setDeviationData(deviationData);

      } else {
        let user = this.getMeBasic;
        let deviationData = {
          type: self.type,
          userId: user.userId,
          userName: user.userName,
          companyId: user.companyId,
          location: self.$route.query.location,
          locationAdditional: self.$route.query.locationAdditional, // barcode of de trailer
          remark: self.remark,
          amount: self.amount,
          orderId: this.$route.query.location === 'loading' ? parseInt(this.$route.query.orderId) : this.$route.query.orderId,
          recordId: this.$route.query.recordId ? this.$route.query.recordId : null,
          pickLocationAtMomentOfRegistering: self.$route.query.picklocation === 'undefined' ? null : self.$route.query.picklocation
        };
        return self.setDeviationData(deviationData);
      }
    },
    setDeviationData(deviationData) {
      let self = this;

      this.$store.dispatch('deviations/set', deviationData).then(() => {
        setTimeout(() => {
          self.$router.go(-1);
          return self.$swal({
            customClass: {
              header: 'align-items-center'
            },
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            type: 'success',
            title: self.$root.$t('deviations.added')
          });
        }, 500);
      });
    }
  },
  created() {
    if (this.$route.query.blockShortage === 'true') {
      this.type = 'unit';
    }
  }
};
</script>


<style lang="scss" scoped>


.image-wrapper {
  position: relative;
  margin-top: 30px;
  background: #fff;
  border: 1px solid #e4e4e4;
  display: block;
  height: 300px;
  text-align: center;
  margin-bottom: 0;

  .camera-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: auto;
    font-size: 65px;
  }

  .loading-image {
    position: absolute;
    left: 40%;
    top: 40%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    overflow: auto;
    font-size: 65px;
  }

  img {
    padding: 10px;
    height: 100%;
    width: 100%
  }
}
</style>
